import React from 'react';
import { connect } from 'react-redux';
import { IMAGE_EXTENSIONS, MIME_TYPES } from 'swag-client-common/utils/constants';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { confirmDtgDispatcher } from '../../../redux/logo-editing/logo-editing.dispatchers';
import { PRINTING_METHODS } from '../../../redux/product/product.constants';
import classes from './confirm-dtg-popup.scss';
function ConfirmDtgPopup({
  onConfirm,
  onUploadAnotherLogo,
  cancelUploading,
  onClose
}) {
  const handleUploadFile = e => {
    var _e$target$files, _e$target;
    const files = (_e$target$files = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files) !== null && _e$target$files !== void 0 ? _e$target$files : [];
    const file = files[0];
    onUploadAnotherLogo(file);
  };
  const content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, "Direct to garment printing"), /*#__PURE__*/React.createElement("p", null, "We noticed your design has more than 8 colors. We are going to use DTG (Direct to garment) printing on this design. Let us know if this is ok. Or upload a design that has fewer than 8 colors."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: classes['upl-btn']
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: `${MIME_TYPES.join(',')}, ${IMAGE_EXTENSIONS.join(',')}`,
    className: classes.hidden,
    onChange: handleUploadFile
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.uploadAnotherButton
  }, "Upload new design")), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: () => {
      onConfirm({
        printingMethod: PRINTING_METHODS.DTG
      });
      onClose();
    }
  }, "Continue")));
  return /*#__PURE__*/React.createElement(ControlDialog, {
    content: content,
    modal: true,
    open: true,
    onRequestClose: () => {
      onClose();
      cancelUploading();
    }
  });
}
export default connect(null, confirmDtgDispatcher)(ConfirmDtgPopup);